import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import {closeModal} from '../../../store/modal/reducer';
import {Box, Modal} from '@mui/material';
import classes from '../modal.module.scss';
import { UpdateTransferForm } from './UpdateTransferForm';

const UpdateTransfer = () =>{

    const dispatch = useAppDispatch();
    const {data: {transfers}} = useAppSelector(state => state.modal);
    const onCloseModal = () => dispatch(closeModal());

    return (
        <Modal
            sx={{
                position:'absolute',
                overflow:'auto',
                height:'100%',
            }}
            open={true}
            className={classes.container}
        >
            <Box
                className={classes.wrapper}
                sx={{
                    position: 'inherit',
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <UpdateTransferForm onCancel={onCloseModal} transfers={transfers} />
            </Box>
        </Modal>
    );

};

export default UpdateTransfer;
